import React, { useContext, useState, useEffect, useReducer } from 'react';
import { default as OrderNew } from './OrderNew';
import { default as OrderPurchase } from './purchase';
import { default as OrderPackage } from './package';
import { default as OrderDelivery } from './delivery';
import {
  getDeliveryById,
  updateDeliveryById,
  getPermissionByOrderId,
  insertPermissionByOrderId,
  getListOrderGoods,
  getOrderPurchaseGoodsByOrderId,
  getOrderPurchaseGoodsByOrderIdBatch,
  getOrderPurchaseByOrderId,
  getOrderPurchaseByOrderIdBatch
} from '../../services/Order';

import moment from 'moment';
import { PermissionList, UserSelect } from '../';
import { Page } from '../../components';
import './style';
import {
  Tabs,
  Row, Col,
  Divider,
  Badge,
  Button,
  Form, Input, Select, DatePicker, InputNumber, Dropdown,
  Modal,
  Progress, Popover
} from 'antd';
import {
  CheckCircleFilled, ExclamationCircleOutlined, SaveOutlined
} from '@ant-design/icons';
import { MasterContext } from '../../App';
import { OrderContext } from './';
import './style';

export default React.forwardRef((props, ref) => {
  const { order_permission, buyers, suppliers } = useContext(OrderContext);
  const { user, currentUser } = useContext(MasterContext);
  const {
    order,
    onSaveCallback,
    onSavePermissionCallback,
    onSavePurchaseCallback,
    onSyncOrderPackages,
    onReturnOrderPackage,
    onCloseCallback,
    reloadOrder,
    downloadOrder,
    downloadPurchase,
    downloadPackage,
    downloadPackagePost,
    downloadPalletDetail,
    downloadInvoice,
    onCancelSplitCountCallback,
    onSplitCountCallback,
    onSplitSpecCallback,
    onCancelSplitSpecCallback,
    setShowGoodsSelect,
    onReviewPurchaseSuppliersCallback } = props;
  const { TabPane } = Tabs;
  const [orderPermission, setOrderPermission] = useState([]);
  const [currentKey, setCurrentKey] = useState('info');
  const [orderGoods, setOrderGoods] = useState([]);
  const [orderPurchaseGoods, setOrderPurchaseGoods] = useState([]);
  const [orderPurchaseGoodsBatch, setOrderPurchaseGoodsBatch] = useState([]);
  const [orderPurchase, setOrderPurchase] = useState(undefined);

  const [tabStatus, setTabStatus] = useState([
    order.order_goods_count > 0 ? true : false,
    (orderPurchase && orderPurchase.is_reviewed && order.order_goods_purchase_count >= order.order_goods_adjust_count) ? true : false,
    order.ok_percent > 0.9999 ? true : false,
    order.delivery_ok_percent > 0.9999 ? true : false
  ]);
  tabStatus[0] = order.order_goods_count > 0 ? true : false;
  tabStatus[1] = (orderPurchase && orderPurchase.is_reviewed && order.order_goods_purchase_count >= order.order_goods_adjust_count) ? true : false;
  tabStatus[2] = order.ok_percent > 0.9999 ? true : false;
  tabStatus[3] = order.delivery_ok_percent > 0.9999 ? true : false;

  const setUserPermissions = (checked, userId, permissionId) => {
    let temp = [].concat(orderPermission);
    if (temp.find(x => x.user_id === userId && x.permission_id === permissionId)) {
      if (!checked) {
        temp.splice(temp.indexOf(temp.find(x => x.user_id === userId && x.permission_id === permissionId)), 1);
      }
    } else {
      if (checked) {
        temp.push({ user_id: userId, permission_id: permissionId });
      }
    }
    setOrderPermission(temp);
  }

  const onSavePermission = () => {
    onSavePermissionCallback(order.id, orderPermission)
  }

  const reloadOrderGoods = () => {
    getListOrderGoods(order.id).then(data =>
      setOrderGoods(data)
    );
  }

  const reloadOrderPurchase = () => {
    getOrderPurchaseByOrderId(order.id).then(data => {
      setOrderPurchase(data)
    });
  }

  const reloadPurchaseGoods = () => {
    getOrderPurchaseGoodsByOrderId(order.id).then(data => {
      const temp = [].concat(orderPurchaseGoods);
      data.forEach(x=> {
        const find = temp.find(y=>y.id === x.id);
        if (find) {
          x.supplier_id = find.supplier_id;
          x.price = find.price;
          x.price_start_time = find.price_start_time;
        }
      })
      setOrderPurchaseGoods(data);
    });
    getOrderPurchaseGoodsByOrderIdBatch(order.id).then(data => {
      setOrderPurchaseGoodsBatch(data);
    });
  }

  const setActiveColor = () => {

    let otherTab = document.getElementsByClassName('ant-tabs-tab');//包含了当前的active
    let i = 0;
    for (let j in otherTab) {
      if (otherTab.hasOwnProperty(j)) {
        let i = otherTab[j]
        if (i.className.includes('ant-tabs-tab-active')) {//当前点击的
          i.style.backgroundColor = '#dcdef5';
          i.style.color = '#fff';
          i.style.height = '36px';
        }
        else {//其他默认的样式
          i.style.backgroundColor = '#fafafa';
          i.style.color = 'rgba(0, 0, 0, 0.65)';
          i.style.height = '36px';
        }
      }
      if (i > 4) break;
      i++;
    }
  }

  useEffect(()=> {
    setActiveColor();
  },[currentKey])
  useEffect(() => {
    getPermissionByOrderId(order.id).then(data =>
      setOrderPermission(data || [])
    );
    reloadOrderPurchase();
    reloadPurchaseGoods();
    reloadOrderGoods();
    setActiveColor();
    const tab = document.getElementsByClassName('ant-tabs-nav-wrap')[0];
    tab.style.height = '36px';
  }, []);

  const onChangeTab = (key) => {
    setCurrentKey(key);
  }


  const callback = () => {
    reloadOrder();
    reloadOrderGoods();
    reloadPurchaseGoods();
  }
  const onSaveOrder = (data) => {
    onSaveCallback(data, callback);
  }

  const checkButtonIcon = (<Button size="small" type="link" icon={<CheckCircleFilled style={{ color: '#52c41a' }} />}></Button>);
  const errorButtonIcon = (<Button size="small" type="link" icon={<ExclamationCircleOutlined style={{ color: '#eb2f96' }} />}></Button>);
  const buyer = buyers.find(x => x.id === order.buyer_id) || {};
  const coOwners = user.filter(x => x.id === order.creater_id || x.id === order.owner_id);
  if (buyer.co_owner1_id && !coOwners.find(x => x.id === buyer.co_owner1_id)) coOwners.push(user.find(x => x.id === buyer.co_owner1_id));
  if (buyer.co_owner2_id && !coOwners.find(x => x.id === buyer.co_owner2_id)) coOwners.push(user.find(x => x.id === buyer.co_owner2_id));
  if (buyer.co_owner3_id && !coOwners.find(x => x.id === buyer.co_owner3_id)) coOwners.push(user.find(x => x.id === buyer.co_owner3_id));
  if (buyer.co_owner4_id && !coOwners.find(x => x.id === buyer.co_owner4_id)) coOwners.push(user.find(x => x.id === buyer.co_owner4_id));
  return (
    <Tabs size="small" style={{ width: '100%', height: '100%', minHeight: '560px' }} onChange={onChangeTab} type="card">
      <TabPane style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto' }} tab={<div>订单信息 {tabStatus[0] === true ? checkButtonIcon : errorButtonIcon}</div>} key="info">
        <OrderNew
          mode="edit"
          orderGoods={orderGoods}
          setOrderGoods={setOrderGoods}
          downloadOrder={downloadOrder}
          setShowGoodsSelect={setShowGoodsSelect}
          onSaveCallback={onSaveOrder}
          onCloseCallback={onCloseCallback}
          order={order} />
      </TabPane>
      <TabPane style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto' }} tab={<div>采购信息 {
        tabStatus[1] === true ? checkButtonIcon : errorButtonIcon
      }</div>} key="purchase">
        <OrderPurchase
          forceRender={true}
          order={order}
          orderGoods={orderGoods}
          orderPurchase={orderPurchase}
          orderPurchaseGoods={orderPurchaseGoods}
          orderPurchaseGoodsBatch={orderPurchaseGoodsBatch}
          setOrderPurchaseGoodsBatch={setOrderPurchaseGoodsBatch}
          reloadPurchaseGoods={reloadPurchaseGoods}
          reloadOrderPurchase={reloadOrderPurchase}
          setOrderPurchaseGoods={setOrderPurchaseGoods}
          downloadPurchase={downloadPurchase}
          onReviewPurchaseSuppliersCallback={onReviewPurchaseSuppliersCallback}
          onSavePurchaseCallback={onSavePurchaseCallback}
          onCancelSplitCountCallback={onCancelSplitCountCallback}
          onSplitCountCallback={onSplitCountCallback}
          onCancelSplitSpecCallback={onCancelSplitSpecCallback}
          onSplitSpecCallback={onSplitSpecCallback}
          onCloseCallback={onCloseCallback}
        />
      </TabPane>
      <TabPane style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto' }} tab={<div>供应商发货信息 {
        tabStatus[2] === true ? checkButtonIcon : errorButtonIcon
      }</div>} key="3">
        <OrderPackage
          order={order}
          suppliers={suppliers}
          tabStatus={tabStatus}
          setTabStatus={setTabStatus}
          onSyncOrderPackages={onSyncOrderPackages}
          onReturnOrderPackages={onReturnOrderPackage}
          onCloseCallback={onCloseCallback}
          downloadPalletDetail={downloadPalletDetail}
          downloadPackage={downloadPackage}
          downloadPackagePost={downloadPackagePost}
           />
      </TabPane>
      <TabPane style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto' }} tab={<div>UPDATE {
        tabStatus[3] === true ? checkButtonIcon : errorButtonIcon
      }</div>} key="4">
        <OrderDelivery
          order={order}
          tabStatus={tabStatus}
          setTabStatus={setTabStatus}
          onCloseCallback={onCloseCallback} />
      </TabPane>
      {
        (currentUser.category_id === 1 || order.creater_id === currentUser.id || order.owner_id === currentUser.id)
        && [
          <TabPane tab="订单权限" key="5">
            <PermissionList
              createrId={order.creater_id}
              ownerId={order.owner_id}
              setUserPermissions={setUserPermissions}
              onCloseCallback={onCloseCallback}
              users={coOwners.map((item) => {
                return  Object.assign({
                  permissions: orderPermission.filter(y => y.user_id === item.id)
                }, item);
              })}
              permissions={order_permission}
              onOk={onSavePermission}
            />
          </TabPane>,
          <TabPane tab="订单操作履历" key="6">
            第二期完成
      </TabPane>]
      }
    </Tabs>
  )
});
